var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiConfused(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 130,
    viewBox: "0 0 131 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BiConfused"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M65.4999 10.8008C35.7186 10.8008 11.4895 35.0299 11.4895 64.8112C11.4895 94.5925 35.7186 118.822 65.4999 118.822C95.2813 118.822 119.51 94.5925 119.51 64.8112C119.51 35.0299 95.2813 10.8008 65.4999 10.8008ZM65.4999 108.02C41.6759 108.02 22.2916 88.6352 22.2916 64.8112C22.2916 40.9872 41.6759 21.6029 65.4999 21.6029C89.3239 21.6029 108.708 40.9872 108.708 64.8112C108.708 88.6352 89.3239 108.02 65.4999 108.02Z",
    fill: "#38B2AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M46.5964 64.8125C51.0708 64.8125 54.698 61.1853 54.698 56.7109C54.698 52.2366 51.0708 48.6094 46.5964 48.6094C42.1221 48.6094 38.4949 52.2366 38.4949 56.7109C38.4949 61.1853 42.1221 64.8125 46.5964 64.8125Z",
    fill: "#38B2AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M84.3658 64.7369C88.8192 64.7369 92.4295 61.1266 92.4295 56.6731C92.4295 52.2196 88.8192 48.6094 84.3658 48.6094C79.9123 48.6094 76.302 52.2196 76.302 56.6731C76.302 61.1266 79.9123 64.7369 84.3658 64.7369Z",
    fill: "#38B2AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M44.5655 91.773L43.2261 81.0573L86.4344 75.6562L87.7739 86.3719L44.5655 91.773Z",
    fill: "#38B2AC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiConfused);
export default __webpack_public_path__ + "static/media/bi_confused.f6094f60da3b497eae7af68192d406ba.svg";
export { ForwardRef as ReactComponent };